"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_datepicker_1 = require("react-datepicker");
const fr_1 = require("date-fns/locale/fr");
const classnames_1 = require("classnames");
class Datepicker extends React.Component {
    render() {
        const { invalid, ...rest } = this.props;
        return (React.createElement(react_datepicker_1.default, Object.assign({ locale: fr_1.default, dateFormat: "d MMMM yyyy HH:mm p", className: "form-control", wrapperClassName: classnames_1.default('d-block', { 'is-invalid': invalid }) }, rest)));
    }
}
exports.default = Datepicker;
